import React from 'react';
import { useProductDescription } from '../hooks/useProductDescription';

const ProductDescriptionCollapse = ({ elementHeight }: any) => {
	const { blockClass, collapseContent, isOpen, setIsOpen } = useProductDescription();

	const renderClass = () => {
		return (
			blockClass &&
			`product-description--${blockClass} vtex-store-components-3-x-showMoreButton--product-description--${blockClass}`
		);
	};
	if (!collapseContent || elementHeight === 'auto') return null;

	return (
		<div
			className={`pointerEventsNone vtex-store-components-3-x-pointerEventsNone absolute bottom-0 w-100 h-100 flex-column justify-end ${collapseContent ? 'flex' : 'dn'}`}
		>
			<div
				className={`fadeBottom vtex-store-components-3-x-fadeBottom w-100 h-50 ${isOpen ? 'o-0' : ''}`}
				style={{
					transition: 'all 400ms ease-in-out 0s',
					backgroundImage: 'linear-gradient(transparent, white)',
				}}
			></div>
			<div
				className={`pointerEventsAuto vtex-store-components-3-x-pointerEventsAuto tc w-100 bg-${isOpen ? 'transparent' : 'base'}`}
			>
				<button
					onClick={() => setIsOpen(!isOpen)}
					className={`showMoreButton vtex-store-components-3-x-showMoreButton ${renderClass()} c-action-primary t-action pointer ma5 bn outline-0`}
				>
					{isOpen ? 'Ver Menos' : 'Ver mais'}
				</button>
			</div>
		</div>
	);
};

export default ProductDescriptionCollapse;
